import LegalLayout from '../components/legal/LegalLayout'
import source, { VERSION, EFFECTIVE_DATE } from '../assets/legal/practiceTerms'

// One document, one page, one chunk. See components/legal/LegalLayout.jsx for
// why these are not a single :slug route.

export default function LegalTerms() {
  return (
    <LegalLayout
      slug="terms"
      title="Terms of Business"
      version={VERSION}
      date={EFFECTIVE_DATE}
      source={source}
    />
  )
}
